<template>
  <div class="table-area">
    <div class ="table-a">
      <table id="basic" class="table infotable" ref = subDetail>
        <tbody>

        <tr>
          <th>상위분류명</th>
          <td colspan="2">
            <input class="input" type="text" v-model="parentNm" disabled>
          </td>

          <th class="tp-a" style="border-left:none">분류명</th>
          <td colspan="2">
            <input class="input" type="text" v-model="form.programNm">
          </td>
        </tr>

        <tr>
          <th class="tp-a">KEY</th>
          <td colspan="2">
            <input class="input" type="text" v-model="form.programKey">
          </td>

          <th>VALUE1</th>
          <td colspan="2">
            <input class="input" type="text" v-model="form.programValue1">
          </td>
        </tr>

        <tr>
          <th>VALUE2</th>
          <td colspan="2">
            <input class="input" type="text" v-model="form.programValue2">
          </td>

          <th>VALUE3</th>
          <td colspan="2">
            <input class="input" type="text" v-model="form.programValue3">
          </td>
        </tr>

        <tr>
          <th>VALUE4</th>
          <td colspan="2">
            <input class="input" type="text" v-model="form.programValue4">
          </td>

          <th>VALUE5</th>
          <td colspan="2">
            <input class="input" type="text" v-model="form.programValue5">
          </td>
        </tr>

        <tr style="height: 90px">
          <th>비고</th>
          <td colspan="5">
            <textarea class="input" type="text" v-model="form.description"/>
          </td>
        </tr>

        <input class="input" type="hidden" v-model="form.programId"/>

        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgramInfo",
  props: ['programDetail' , 'parentNm'],
  data() {
    return {
      form: {
        programKey: "",
        programNm: "",
        programId: "",
        parentId: "",
        TopKey: "",
        programIdx: "",
        description: "",
        programValue1: "",
        programValue2: "",
        programValue3: "",
        programValue4: "",
        programValue5: "",
      },
      // eslint-disable-next-line vue/no-dupe-keys
      parentNm: "",
    };
  },
  methods: {
    setprogramInfo() {
      Object.assign(this.form, this.programDetail, this.parentNm);
    },
  },
  watch: {
    programDetail() {
      this.setprogramInfo();
    }
  }
}

</script>

<style scoped>

</style>